import { useH5PreviewPreference } from '@/views/home/preview'
import usePreference from '@teams/common/hooks/usePreference'
import {
  AllLayoutStylesKeysType,
  AllThemeStylesKeysType
} from '@teams/common/store/preference/constant'
import {
  lightGreenSymbol,
  lightOrangeSymbol,
  lightBlueSymbol,
  defaultThemeSymbol,
  themeColorPanelList
} from '@teams/common/config/colorTheme/themes'
import { computed } from 'vue'
import customNavLayoutUnderline from '@/assets/customLayout/customNavLayoutUnderline.svg'
import customNavLayoutCapsule from '@/assets/customLayout/customNavLayoutCapsule.svg'
import customNavLayoutSquare from '@/assets/customLayout/customNavLayoutSquare.svg'
import { ICustomItem } from './useData'

export interface ICustomPanalProps {
  pageHeadHeight?: string
  showTeamMemory: boolean
  showTeamAvatar: boolean
  showMessage: boolean
  showTeamShare: boolean
  showNavBar: boolean
  navBarPosition: string
  navBarContentLayout: 'simple' | 'normal' | 'vertical'
  isEase: boolean
}
export interface IColorOption {
  title: string
  color: string
  onColorChange: (color: string) => void
}
export interface ICustomThemeProps {
  currentThemeColor: string
  globalColorOptions: IColorOption[]
  pageHeadColorOptions: IColorOption[]
  navBarColorOptions: IColorOption[]
  navBarItemStyle: {
    key: 'capsule' | 'line' | 'card'
    options: ICustomItem[]
  }
  isUsePcBackgroundToH5?: boolean
  backgroundCoverMask: {
    visible: boolean
    color: string
    onChange: (value: boolean) => void
  }
}
export const useCustomePanal = (client: 'h5' | 'pc') => {
  // TODO: 本地存储初始化在这处理
  const preference = usePreference({ defaultClient: client })
  const h5Preference = useH5PreviewPreference()
  const H5CustomPanalProps = computed<ICustomPanalProps>(() => ({
    showMessage: preference.current.layout.showMessageButton !== 'false',
    showTeamShare: preference.current.layout.showShareButton !== 'false',
    showTeamAvatar: preference.current.layout.showAvatarGroup !== 'false',
    showTeamMemory: preference.current.layout.showTeamMemory !== 'false',
    showNavBar: preference.current.layout.showNavBar !== 'false',
    navBarPosition:
      (preference.current.layout.navBarPosition as string) || 'top',
    navBarContentLayout:
      (preference.current.layout.navContentLayout as any) || 'normal',
    isEase: preference.current.layout.isEase === 'true'
  }))
  const PCCustomPanalProps = computed<ICustomPanalProps>(() => ({
    showMessage: preference.current.layout.hiddenMessageAlert !== 'true',
    showTeamShare: preference.current.layout.hiddenShareBtn !== 'true',
    showTeamAvatar: preference.current.layout.hiddenTeamMember !== 'true',
    showTeamMemory: preference.current.layout.hiddenTeamSpace !== 'true',
    showNavBar: preference.current.layout.showNavBar !== 'false',
    navBarPosition:
      (preference.current.layout.navBarPosition as string) || 'top',
    navBarContentLayout:
      (preference.current.layout.navContentLayout as any) || 'normal',
    isEase: preference.current.layout.isEase === 'true'
  }))
  const H5CustomThemeProps = computed<ICustomThemeProps>(() => ({
    currentThemeColor: computed(
      () =>
        themeColorPanelList[
          preference.current.theme.styles['theme-color-panel'] as string
        ] ||
        (preference.current.theme.styles['theme-color-panel'] as string) ||
        themeColorPanelList[defaultThemeSymbol]
    ).value,
    globalColorOptions: [
      {
        title: '背景颜色',
        color: '#3B3D40',
        onColorChange: (color: string) => {
          console.log(color)
          // handleThemeChange('')
        }
      }
    ],
    pageHeadColorOptions: [
      {
        title: '背景图蒙层',
        color:
          (preference.current.theme.styles[
            'H5-background-mask-color'
          ] as string) || '#00000000',
        onColorChange: (color: string) => {
          handleThemeChange('H5-background-mask-color', color)
        }
      },
      {
        title: '空间名称颜色',
        color:
          (preference.current.theme.styles[
            'H5-group-head-name-color'
          ] as string) || getDefaultThemeColor('text-01'),
        onColorChange: (color: string) => {
          handleThemeChange('H5-group-head-name-color', color)
        }
      },
      {
        title: '空间简介颜色',
        color:
          (preference.current.theme.styles[
            'H5-group-head-desc-color'
          ] as string) || getDefaultThemeColor('text-02'),
        onColorChange: (color: string) => {
          handleThemeChange('H5-group-head-desc-color', color)
        }
      }
      // H5空间底色先不做
      // ,
      // {
      //   title: '空间名称底色',
      //   color: preference.current.theme.styles[
      //     'H5-group-head-background-color'
      //   ] as string,
      //   onColorChange: (color: string) => {
      //     handleThemeChange('H5-group-head-background-color', color)
      //   }
      // }
    ],
    navBarColorOptions: [
      {
        title: '导航栏背景颜色',
        color:
          (preference.current.theme.styles[
            'H5-nav-background-color'
          ] as string) || getDefaultThemeColor('theme-team-06'),
        onColorChange: (color: string) => {
          handleThemeChange('H5-nav-background-color', color)
        }
      },
      {
        title: '选中标签填充颜色',
        color:
          (preference.current.theme.styles[
            'H5-nav-active-fill-color'
          ] as string) || getDefaultThemeColor('theme-team-01'),
        onColorChange: (color: string) => {
          handleThemeChange('H5-nav-active-fill-color', color)
        }
      },
      {
        title: '选中标签文字颜色',
        color:
          (preference.current.theme.styles[
            'H5-nav-active-text-color'
          ] as string) || getDefaultThemeColor('text-01'),
        onColorChange: (color: string) => {
          handleThemeChange('H5-nav-active-text-color', color)
        }
      },
      {
        title: '未选中标签文字颜色',
        color:
          (preference.current.theme.styles[
            'H5-nav-default-text-color'
          ] as string) || getDefaultThemeColor('text-02'),
        onColorChange: (color: string) => {
          handleThemeChange('H5-nav-default-text-color', color)
        }
      },
      {
        title: '导航栏边缘分割线',
        color:
          (preference.current.theme.styles['H5-nav-border-color'] as string) ||
          getDefaultThemeColor('separator-03'),
        onColorChange: (color: string) => {
          handleThemeChange('H5-nav-border-color', color)
        }
      }
    ],
    navBarItemStyle: {
      key:
        (preference.current.theme.styles['H5-nav-style-type'] as any) ?? 'card',
      options: [
        {
          key: 'line',
          des: '下划线型',
          imgUrl: customNavLayoutUnderline,
          onSelect: () => handleThemeChange('H5-nav-style-type', 'line')
        },
        {
          key: 'capsule',
          des: '胶囊型',
          imgUrl: customNavLayoutCapsule,
          onSelect: () => handleThemeChange('H5-nav-style-type', 'capsule')
        },
        {
          key: 'card',
          des: '方型',
          imgUrl: customNavLayoutSquare,
          onSelect: () => handleThemeChange('H5-nav-style-type', 'card')
        }
      ]
    },
    backgroundCoverMask: {
      visible:
        preference.current.theme.styles['PC-background-blur-mask-visible'] ===
        'true',
      color:
        (preference.current.theme.styles[
          'PC-background-mask-color'
        ] as string) ?? 'FFFFFF',
      onChange: (value: boolean) => {
        handleThemeChange('H5-background-blur-mask-visible', value.toString())
      }
    }
  }))
  const PCCustomThemeProps = computed<ICustomThemeProps>(() => ({
    currentThemeColor: computed(
      () =>
        themeColorPanelList[
          preference.current.theme.styles['theme-color-panel'] as string
        ] ||
        (preference.current.theme.styles['theme-color-panel'] as string) ||
        themeColorPanelList[defaultThemeSymbol]
    ).value,
    globalColorOptions: [
      {
        title: '背景颜色',
        color: '#3B3D40',
        onColorChange: (color: string) => {
          console.log(color)
          // handleThemeChange('')
        }
      }
    ],
    pageHeadColorOptions: [
      {
        title: '背景图蒙层',
        color:
          (preference.current.theme.styles[
            'PC-background-mask-color'
          ] as string) || '#00000000',
        onColorChange: (color: string) => {
          handleThemeChange('PC-background-mask-color', color)
        }
      },
      {
        title: '空间名称颜色',
        color:
          (preference.current.theme.styles[
            'PC-group-head-name-color'
          ] as string) || getDefaultThemeColor('text-01'),
        onColorChange: (color: string) => {
          handleThemeChange('PC-group-head-name-color', color)
        }
      },
      {
        title: '空间简介颜色',
        color:
          (preference.current.theme.styles[
            'PC-group-head-desc-color'
          ] as string) || getDefaultThemeColor('text-02'),
        onColorChange: (color: string) => {
          handleThemeChange('PC-group-head-desc-color', color)
        }
      },
      {
        title: '空间名称底色',
        color: preference.current.theme.styles[
          'PC-group-head-background-color'
        ] as string,
        onColorChange: (color: string) => {
          handleThemeChange('PC-group-head-background-color', color)
        }
      }
    ],
    navBarColorOptions: [
      {
        title: '导航栏背景颜色',
        color:
          (preference.current.theme.styles[
            'PC-nav-background-color'
          ] as string) || getDefaultThemeColor('theme-team-06'),
        onColorChange: (color: string) => {
          handleThemeChange('PC-nav-background-color', color)
        }
      },
      {
        title: '选中标签填充颜色',
        color:
          (preference.current.theme.styles[
            'PC-nav-active-fill-color'
          ] as string) || getDefaultThemeColor('theme-team-02'),
        onColorChange: (color: string) => {
          handleThemeChange('PC-nav-active-fill-color', color)
        }
      },
      {
        title: '选中标签文字颜色',
        color:
          (preference.current.theme.styles[
            'PC-nav-active-text-color'
          ] as string) || getDefaultThemeColor('text-01'),
        onColorChange: (color: string) => {
          handleThemeChange('PC-nav-active-text-color', color)
        }
      },
      {
        title: '未选中标签文字颜色',
        color:
          (preference.current.theme.styles[
            'PC-nav-default-text-color'
          ] as string) || getDefaultThemeColor('text-02'),
        onColorChange: (color: string) => {
          handleThemeChange('PC-nav-default-text-color', color)
        }
      },
      {
        title: '导航栏边缘分割线',
        color:
          (preference.current.theme.styles['PC-nav-border-color'] as string) ||
          getDefaultThemeColor('separator-03'),
        onColorChange: (color: string) => {
          handleThemeChange('PC-nav-border-color', color)
        }
      }
    ],
    navBarItemStyle: {
      key:
        (preference.current.theme.styles['PC-nav-style-type'] as any) ?? 'card',
      options: [
        {
          key: 'line',
          des: '下划线型',
          imgUrl: customNavLayoutUnderline,
          onSelect: () => handleThemeChange('PC-nav-style-type', 'line')
        },
        {
          key: 'capsule',
          des: '胶囊型',
          imgUrl: customNavLayoutCapsule,
          onSelect: () => handleThemeChange('PC-nav-style-type', 'capsule')
        },
        {
          key: 'card',
          des: '方型',
          imgUrl: customNavLayoutSquare,
          onSelect: () => handleThemeChange('PC-nav-style-type', 'card')
        }
      ]
    },
    backgroundCoverMask: {
      visible:
        preference.current.theme.styles['PC-background-blur-mask-visible'] ===
        'true',
      color:
        (preference.current.theme.styles[
          'H5-background-mask-color'
        ] as string) ?? 'FFFFFF',

      onChange: (value: boolean) => {
        handleThemeChange('PC-background-blur-mask-visible', value.toString())
      }
    },
    isUsePcBackgroundToH5:
      preference.current.theme.styles['use-pc-background-to-h5'] === 'true'
  }))

  const handleLayoutChange = (key: AllLayoutStylesKeysType, value: string) => {
    if (client === 'h5') {
      return h5Preference.changeCurrentPreference({
        layouts: [{ key: key, value: value.toString() }]
      })
    }
    preference.changeCurrentLayoutStyle([{ key: key, value: value }])
  }

  const handleThemeChange = (key: AllThemeStylesKeysType, value: string) => {
    if (client === 'h5') {
      return h5Preference.changeCurrentPreference({
        themes: [{ key: key, value: value }]
      })
    }
    preference.changeCurrentThemeStyle([{ key: key, value: value }])
  }

  const handleThemeColorChange = (value: string) => {
    const colorMap = {
      '#2C71FA': lightBlueSymbol,
      '#10A341': lightGreenSymbol,
      '#FF980F': lightOrangeSymbol
    }

    const colorValue = colorMap[value] ?? value
    if (client === 'h5') {
      return h5Preference.changeCurrentPreference({
        themes: [{ key: 'theme-color-panel', value: colorValue }]
      })
    }
    preference.changeCurrentThemeStyle([
      { key: 'theme-color-panel', value: colorValue }
    ])
  }

  const handleRefreshCustomTheme = () => {
    if (client === 'h5') {
      h5Preference.refresh()
    }
    preference.refreshCurrentTheme()
  }

  const handleSaveCustomTheme = () => {
    preference.saveCurrentTheme().then(() => {
      preference.refreshPreference()
    })
  }

  const getDefaultThemeColor = (key: string) => {
    try {
      return computed(() => {
        const value = preference.getCurrentColorThemeCSSVars()
        return value[key]
      }).value
    } catch (error) {
      return '#00000000'
    }
  }

  // const getDefaultThemeColor = (key: string) => {
  //   try {
  //     return computed(
  //       () =>
  //         themes[
  //           `${
  //             preference.current.theme.styles['theme-color-panel'] ||
  //             defaultThemeSymbol
  //           }`
  //         ][key]
  //     ).value
  //   } catch (error) {
  //     return null
  //   }
  // }
  return {
    H5CustomPanalProps,
    PCCustomPanalProps,
    H5CustomThemeProps,
    PCCustomThemeProps,
    handleLayoutChange,
    handleThemeChange,
    handleThemeColorChange,
    handleRefreshCustomTheme,
    handleSaveCustomTheme,
    preference,
    h5Preference
  }
}
